module.exports = __webpack_public_path__ + "static/media/creative_03.51df7cfd.jpg";